import axios from '@/plugins/api.request'

/**
 * 赛事列表
 * @param {*} data
 */
export const list = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.Judges.MatchList',
    data
  })
}
/**
 * 可参评列表
 * @param {*} data
 */
export const teamList = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.Judges.ScheduleTeamList',
    data
  })
}

/**
 * 评委查看作品
 * @param {*} data
 */
export const teamWork = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.Judges.TeamWork',
    data
  });
}

/**
 * 提交或修改评分
 * @param {*} data
 */
export const workScore = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.Judges.WorkScore',
    data
  });
}

